import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  Typography,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QRCode from "react-qr-code";

const BalanceModal = ({ open, onClose, balanceData }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  // Получаем user из localStorage
  let merchantAccount = '';
  try {
    const userStr = localStorage.getItem('user');
    const user = JSON.parse(userStr);
    merchantAccount = user?.phone || '';
  } catch (e) {
    merchantAccount = '';
  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '360px',
          borderRadius:'12px',
          paddingY:'8px' // Максимальная ширина модального окна
        },
      }}
    >
      <DialogTitle>
        Пополнение баланса
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            marginTop:'4px',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label="balance tabs"
            sx={{
              '& .MuiTab-root': {
                color: 'black',
              },
              '& .MuiTab-root.Mui-selected': {
                color: '#EE6F42',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#EE6F42',
              },
            }}
          >
            <Tab label="Alif Mobi" />
          </Tabs>
        </Box>
        <TabPanel value={selectedTab} index={0}>
          <Typography variant="body1" align="center" sx={{ mt: 2 }}>
            Сканируйте QR-код чтобы пополнить баланс или используйте приложение:
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <QRCode
              value={`https://alifmobi.page.link/providers?id=1234&amount=100&account=${merchantAccount}`}
              size={200}
            />
          </Box>
        
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: '#EE6F42', '&:hover': { bgcolor: '#ff7f3f' } }}
              className="sm:hidden"
              component="a"
              href={`https://alifmobi.page.link/providers?id=1234&amount=100&account=${merchantAccount}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Пополнить через Алиф
            </Button>
            <Button variant="outlined" onClick={onClose} sx={{ borderColor: '#EDEDED', color: '#737C86' }}>
              Закрыть
            </Button>
          </Box>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default BalanceModal; 